import { render, staticRenderFns } from "./GiftSkuSelectForm.vue?vue&type=template&id=fbf8446e"
import script from "./GiftSkuSelectForm.vue?vue&type=script&lang=js"
export * from "./GiftSkuSelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports